import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewquanlytonkhoAction } from 'src/actions/newquanlytonkho.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
} from '@material-ui/core';

import { Settings, Download, Upload, Cached, ReportProblem } from '@material-ui/icons';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import { isGrantPermission } from 'src/utils/utils';
import { NewdanhmucnhacungcapAction } from 'src/actions/newdanhmucnhacungcap.action';

import CreateEditDialogNewdanhmucnhacungcap from '../newdanhmucnhacungcap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieunhap from '../newdanhmucphieunhap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieuxuat from '../newdanhmucphieuxuat-detail/CreateEditDialog';
import CreateEditDialogDieuChuyen from './CreateEditDialogDieuChuyen';
import CreateEditDialogDieuChuyenLichSu from './CreateEditDialogDieuChuyenLichSu';

import { NewdanhmucphieunhapAction } from 'src/actions/newdanhmucphieunhap.action';
import { NewdanhmucphieuxuatAction } from 'src/actions/newdanhmucphieuxuat.action';

const ViewDanhSachTon = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected_laydanhsachton } = useSelector(state => state.newquanlytonkho)
    const { info, permissions, role } = useSelector(state => state.profile)
    const [ma, setMa] = useState("")
    const [ten, setTen] = useState("")
    const [gia_nhap, setGiaNhap] = useState("0")
    const [gia_thuc_nhap_si_1, setGiaThucNhapSi1] = useState("0")
    const [gia_thuc_nhap_si_2, setGiaThucNhapSi2] = useState("0")
    const [gia_thuc_nhap_si_3, setGiaThucNhapSi3] = useState("0")
    const [giaxuat1, setGiaXuat1] = useState("0")
    const [giaxuat2, setGiaXuat2] = useState("0")
    const [giaxuat3, setGiaXuat3] = useState("0")
    const [chiet_khau_1, setChietKhau1] = useState("0")
    const [chiet_khau_2, setChietKhau2] = useState("0")
    const [chiet_khau_3, setChietKhau3] = useState("0")

    const [nhacungcap_id, setNhacungcapId] = useState("-99");
    const [nhacungcap_name, setNhacungcapName] = useState("");
    const [nhacungcap_select, setNhacungcapSelect] = useState(undefined);
    const [nhacungcapList, setNhacungcapList] = useState([]);

    const additionalOptionNhacungcap = { 'id': '-99', 'ma': 'Nhà cung cấp...', 'ten': '' };

    const [openNewdanhmucnhacungcap, setOpenNewdanhmucnhacungcap] = useState(false);
    const [openNewdanhmucphieunhap, setOpenNewdanhmucphieunhap] = useState(false);
    const [openNewdanhmucphieuxuat, setOpenNewdanhmucphieuxuat] = useState(false);

    const [openDieuChuyen, setOpenDieuChuyen] = useState(false);
    const [openDieuChuyenLichSu, setOpenDieuChuyenLichSu] = useState(false);

    const [dieuChuyenSoKhung, setDieuChuyenSoKhung] = useState("");
    const [dieuChuyenSoMay, setDieuChuyenSoMay] = useState("");

    //==========

    const handleClickOpenNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(true);
    };

    const handleCloseNewdanhmucnhacungcap = () => {
        setOpenNewdanhmucnhacungcap(false);
        fetchData();
    };

    //==========

    const onSelectedNewdanhmucphieunhap = (id) => {
        dispatch(NewdanhmucphieunhapAction.findOne(id));
        setOpenNewdanhmucphieunhap(true);
    };

    const handleClickOpenNewdanhmucphieunhap = () => {
        setOpenNewdanhmucphieunhap(true);
    };

    const handleCloseNewdanhmucphieunhap = () => {
        setOpenNewdanhmucphieunhap(false);
    };

    //==========

    const onSelectedNewdanhmucphieuxuat = (id) => {
        dispatch(NewdanhmucphieuxuatAction.findOne(id));
        setOpenNewdanhmucphieuxuat(true);
    };

    const handleClickOpenNewdanhmucphieuxuat = () => {
        setOpenNewdanhmucphieuxuat(true);
    };

    const handleCloseNewdanhmucphieuxuat = () => {
        setOpenNewdanhmucphieuxuat(false);
    };

    //==========

    const fetchData = async() => {
        // const _nhacungcapList = await dispatch(NewdanhmucnhacungcapAction.nhacungcapList());
        // if (_nhacungcapList && typeof _nhacungcapList.data !== 'undefined' && typeof _nhacungcapList.data.values !== 'undefined') setNhacungcapList(_nhacungcapList.data.values);
    }

    useEffect(() => {
        console.log(selected_laydanhsachton);
    }, [props])

    const dieuChuyenLichSu = (so_khung, so_may) => {
        console.log(so_khung, so_may);
        setDieuChuyenSoKhung(so_khung);
        setDieuChuyenSoMay(so_may)
        setOpenDieuChuyenLichSu(true);
    };

    const handleCloseDieuChuyenLichSu = () => {
        setOpenDieuChuyenLichSu(false);
    };

    const dieuChuyen = (so_khung, so_may) => {
        console.log(so_khung, so_may);
        setDieuChuyenSoKhung(so_khung);
        setDieuChuyenSoMay(so_may)
        setOpenDieuChuyen(true);
    };

    const handleCloseDieuChuyen = () => {
        setOpenDieuChuyen(false);
    };

    const refreshDanhSachSoKhungSoMay = () => {
        if (props?.id_san_pham_chon) {
            dispatch(NewquanlytonkhoAction.layDanhSachTon(props?.id_san_pham_chon?.id, {
                startDate: props?.id_san_pham_chon?.startDate,
                endDate: props?.id_san_pham_chon?.endDate,
            }));
        }
    };

    return (<>
        {selected_laydanhsachton && selected_laydanhsachton.length > 0 && <Dialog className='khophieu-view' open={props.open} onClose={props.handleClose}>
            <DialogTitle>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={refreshDanhSachSoKhungSoMay}
                    style={{ background: 'transparent', height: '20px', padding: 0, width: '20px', minWidth: '20px', marginTop: '-5px', marginLeft: '5px', marginRight: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
                >
                    <Cached style={{ color: "#3498db" }} />
                </Button>
                Chi tiết tồn kho của sản phẩm [<span style={{color: 'red', fontWeight: 'bold'}}>{selected_laydanhsachton?.[0]?.sanpham_ma}</span> (<span style={{color: 'red', fontWeight: 'bold'}}>{selected_laydanhsachton?.[0]?.sanpham_ten}</span>)]
            </DialogTitle>
            <DialogContent style={{ width: '100%', paddingTop: 20 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Số khung</TableCell>
                            <TableCell>Số máy</TableCell>
                            <TableCell>Kho</TableCell>
                            <TableCell>Điều chuyển</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selected_laydanhsachton &&
                            selected_laydanhsachton
                                .map((item, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            key={item.so_khung + '_' + index}
                                        >
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{item.so_khung}</TableCell>
                                            <TableCell>{item.so_may}</TableCell>
                                            <TableCell>{item.khohang_ma} ({item.khohang_ten})</TableCell>
                                            <TableCell>
                                                <button
                                                    type="button"
                                                    onClick={() => dieuChuyen(item.so_khung, item.so_may)}
                                                    className="link-button"
                                                >
                                                    Điều chuyển
                                                </button> | <button
                                                    type="button"
                                                    onClick={() => dieuChuyenLichSu(item.so_khung, item.so_may)}
                                                    className="link-button"
                                                >
                                                    Xem lịch sử
                                                </button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Đóng</Button>
            </DialogActions>
            <CreateEditDialogNewdanhmucnhacungcap open={openNewdanhmucnhacungcap} handleClose={handleCloseNewdanhmucnhacungcap} type={"CREATE"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucphieunhap open={openNewdanhmucphieunhap} handleClose={handleCloseNewdanhmucphieunhap} type={"EDIT"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucphieuxuat open={openNewdanhmucphieuxuat} handleClose={handleCloseNewdanhmucphieuxuat} type={"EDIT"} creatingFromAway={true} />
            <CreateEditDialogDieuChuyen open={openDieuChuyen} handleClose={handleCloseDieuChuyen} type={"EDIT"} creatingFromAway={false} so_khung={dieuChuyenSoKhung} so_may={dieuChuyenSoMay} />
            <CreateEditDialogDieuChuyenLichSu open={openDieuChuyenLichSu} handleClose={handleCloseDieuChuyenLichSu} type={"EDIT"} creatingFromAway={false} so_khung={dieuChuyenSoKhung} so_may={dieuChuyenSoMay} />
        </Dialog >}
    </>);
}

export default ViewDanhSachTon;